import { render, staticRenderFns } from "./AppNavigation.vue?vue&type=template&id=021f46d6&scoped=true"
import script from "./AppNavigation.vue?vue&type=script&lang=js"
export * from "./AppNavigation.vue?vue&type=script&lang=js"
import style0 from "./AppNavigation.vue?vue&type=style&index=0&id=021f46d6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021f46d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('021f46d6')) {
      api.createRecord('021f46d6', component.options)
    } else {
      api.reload('021f46d6', component.options)
    }
    module.hot.accept("./AppNavigation.vue?vue&type=template&id=021f46d6&scoped=true", function () {
      api.rerender('021f46d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation.vue"
export default component.exports